module.exports = __webpack_public_path__ + "static/media/our-product.3d874394.jpg";